module.exports = __webpack_public_path__ + "fonts/LidlFontCondPro-Regular.woff2";